module.exports = __webpack_public_path__ + "static/media/arryn_token.d3b39a5c.png";